var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAttachmentIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0831 4.29461C14.8606 3.0332 12.866 3.0332 11.6434 4.29461L5.04826 11.1328C4.30831 11.8963 4.30831 13.1245 5.04826 13.888C5.7882 14.6515 6.97855 14.6515 7.7185 13.888L11.8043 9.639C12.0617 9.37344 12.0617 8.9751 11.8043 8.70954C11.5469 8.44398 11.1609 8.44398 10.9035 8.70954L6.78552 12.9253C6.56032 13.1577 6.17426 13.1577 5.94906 12.9253C5.72386 12.6929 5.72386 12.2946 5.94906 12.0622L12.5442 5.22407C13.252 4.49378 14.4424 4.49378 15.1501 5.22407C15.8579 5.95436 15.8579 7.18257 15.1501 7.91286L8.55496 14.751C7.33244 16.0124 5.36997 16.0124 4.17962 14.751C2.9571 13.4896 2.9571 11.4647 4.17962 10.2365L10.0992 4.12863C10.3566 3.86307 10.3566 3.46473 10.0992 3.19917C9.84182 2.93361 9.45576 2.93361 9.19839 3.19917L3.27882 9.27386C1.57373 11.0332 1.57373 13.9212 3.27882 15.6805C4.98391 17.4398 7.78284 17.4398 9.48794 15.6805L16.0831 8.87552C17.3056 7.61411 17.3056 5.55602 16.0831 4.29461Z",
    fill: "#AAAAAA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttachmentIcon);
export default __webpack_public_path__ + "static/media/attachment_icon.6c277ec600703a674c45bb8b4f25a5d4.svg";
export { ForwardRef as ReactComponent };